<template>
  <div class="insurance-detail">
    <div class="developing-bg"></div>
    <div class="developing-text">
      <div class="text-message">{{$route.params.msg}}</div>
      <div class="text-phone">
        <span>电话号码：</span><a class="contact" :href="'tel:' + $route.params.contact">{{$route.params.contact}}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'insuranceDetail',
}
</script>

<style lang="less" scoped>
.insurance-detail {
  height: 100%;
  padding: 63px 62px;
  .developing-bg {
    width: 250px;
    height: 196px;
    background: url('../../assets/img/common/developing.png') no-repeat;
    background-size: 100% 100%;
    margin-bottom: 25px;
  }
  .developing-text {
    color: #999999;
    font-size: 13px;
    line-height: 18px;
    .text-message {
      word-break: break-all;
    }
    .contact {
      color: #FF6F00;
    }
  }
}

</style>